export default {
  clientId: ["bm_web_prod", "bm_ios_prod"],
  entry: () => import("./main.jsx"),
};
